module.exports = __webpack_public_path__ + "static/media/loader.d9ae055f.gif";